<template>
  <v-main style="min-height: 70vh">
    <v-container class="responsive-template-content">
      <v-row dense>
        <PersonalInformationForm />
        <UpdatePasswordForm />
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import PersonalInformationForm from "@/components/Candidate/PersonalInformationForm.vue";
import UpdatePasswordForm from "@/components/Candidate/UpdatePasswordForm.vue";
import Vue from "vue";

export default Vue.extend({
  name: "CandidateMyAccount",
  components: { PersonalInformationForm, UpdatePasswordForm },
  data: function () {
    return {
      selectItems: ["Femme", "Homme"],
      activePicker: null,
      date: null,
      menu: false,
      show1: false,
      password: "Password",
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
  },
});
</script>

<style scoped></style>
